/**
 * The follow states the server answers with (ISSUE-1369). The client never
 * works one out: it renders whatever `followState` the last read or write
 * returned.
 */
export type typeFollowState = "none" | "requested" | "following";

export function isFollowState(value: unknown): value is typeFollowState {
  return value === "none" || value === "requested" || value === "following";
}
